import React from "react";
import ServiceRequestForm from "./ServiceRequestForm";

export default function PlumbingServiceRequestForm() {
  return <ServiceRequestForm serviceType="PlumbingService" title="Plumbing" />;
}

